// src/components/legal/AceptaLegal.jsx
//
// «ACEPTA PARA CONTINUAR» (LEGAL.md, L4)
//
// Para las cuentas que YA existían cuando se publicaron los términos y el aviso
// de privacidad. Rob, 17-09-2026: se le pide una vez y, si la cierra sin
// aceptar, se le vuelve a preguntar la próxima vez —«molestar a quien ya paga es
// el camino corto para que se vaya»—.
//
// Por eso NO bloquea y por eso «Ahora no» no guarda nada: solo lo quita de la
// pantalla hasta la siguiente carga. Lo único que se guarda es el «Acepto», con
// la versión de cada documento.

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { aceptaLegal } from './useLegalPendiente.js';
import './AceptaLegal.css';

// ── OJO: ESTA LISTA FILTRA ──────────────────────────────────────────────────
//  `utiles` descarta los documentos que no estén aquí. Es una protección —no
//  enseñar un enlace roto— pero tiene un filo: un documento que el servidor
//  pide y esta lista no conoce se descarta EN SILENCIO, y esa persona se queda
//  pendiente para siempre sin que nadie se entere.
//
//  Pasó al añadir la declaración de edad el 28-09-2026: el backend ya la pedía
//  y el modal la tiraba. Si se añade un documento a `ACEPTABLES` en el backend,
//  tiene que entrar AQUÍ y tener su ruta en `App.jsx`.
const RUTAS = {
  terminos: { ruta: '/terminos', nombre: 'Términos y condiciones' },
  privacidad: { ruta: '/privacidad', nombre: 'Aviso de privacidad' },
  edad: { ruta: '/edad', nombre: 'Declaración de edad' },
};

function temaGuardado() {
  try { return localStorage.getItem('theme') === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
}

export default function AceptaLegal({ documentos = [], onAceptado }) {
  const [cerrado, setCerrado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');
  const [tema] = useState(temaGuardado);

  const utiles = documentos.filter((d) => RUTAS[d.id]);
  if (cerrado || utiles.length === 0) return null;

  async function acepta() {
    setEnviando(true);
    setError('');
    const versiones = Object.fromEntries(utiles.map((d) => [d.id, d.version]));
    const r = await aceptaLegal(versiones);
    setEnviando(false);
    if (r.ok) { onAceptado?.(); return; }
    if (r.status === 409) {
      setError('Los documentos cambiaron mientras los leías. Ábrelos otra vez y vuelve a aceptar.');
      return;
    }
    setError('No se pudo guardar. Revisa tu conexión e inténtalo de nuevo.');
  }

  return (
    <aside className="al-tarjeta" data-tema={tema} data-prueba="acepta-legal"
      role="region" aria-label="Documentos por aceptar">
      <h2 className="al-titulo">Acepta para continuar</h2>
      <p className="al-texto">
        Para seguir usando NSL, acepta {utiles.length === 1 ? 'este documento' : 'estos documentos'}:
      </p>
      <ul className="al-lista">
        {utiles.map((d) => (
          <li key={d.id}>
            <Link to={RUTAS[d.id].ruta} target="_blank" rel="noopener">{RUTAS[d.id].nombre}</Link>
          </li>
        ))}
      </ul>
      {error ? <p className="al-error" role="alert">{error}</p> : null}
      <div className="al-botones">
        <button type="button" className="al-btn al-btn--ok" onClick={acepta} disabled={enviando}>
          {enviando ? 'Guardando…' : 'Acepto y continúo'}
        </button>
        <button type="button" className="al-btn al-btn--texto" onClick={() => setCerrado(true)}
          disabled={enviando}>
          Ahora no
        </button>
      </div>
    </aside>
  );
}
